// Get the quantity input element
const quantityInput = document.querySelector(".quantity__input.product");

console.log("quantityInput", quantityInput);

// Add an event listener to the input field
quantityInput?.addEventListener("change", function (event) {
  const quantity = parseInt(event.target.value);
  updateTieredPricing(quantity);
});

async function updateTieredPricing(quantity) {
  const response = await fetch("?view=tiered-pricing");
  const responseText = await response.text();
  const html = new DOMParser().parseFromString(responseText, "text/html");
  const tierPricingDiv = html.querySelector("#tier-pricing-data");

  if (tierPricingDiv) {
    const tierPricingJson = tierPricingDiv.innerText;
    const tierPricingData = JSON.parse(tierPricingJson);
    let matchingTier = null;

    for (const tier of tierPricingData.tiers) {
      if (quantity >= tier.quantity) {
        matchingTier = tier;
      } else {
        break;
      }
    }

    const caseCountContainer = document.querySelector("#case-count");
    let caseCount = null;
    if (caseCountContainer) {
      caseCount = Number(caseCountContainer.getAttribute("case-count"));
    }

    if (matchingTier) {
      const prefix = matchingTier.price.toFixed(3);

      let MainContainer = document.querySelector(".price__regular");
      let priceContainer = MainContainer.querySelector(".price-item.price-item--regular");
      let updatedPrice = `
            <price-money>
                <bdi>
                    <span class="price__prefix">$</span>${prefix}
                </bdi>
            </price-money>
            `;
      priceContainer.innerHTML = updatedPrice;

      if (caseCount) {
        document.querySelector("#unit-price").innerHTML = `$${(
          matchingTier.price / caseCount
        ).toFixed(3)}`;
      }
    } else {
      console.log("No tier pricing available.", tierPricingDiv.getAttribute("price"));
      const price = Number(tierPricingDiv.getAttribute("price"));
      const convertedNumber = price / 100; // 6.83

      const prefix = convertedNumber.toFixed(3);
      console.log("prefix", prefix);

      let MainContainer = document.querySelector(".price__regular");
      let priceContainer = MainContainer.querySelector(".price-item.price-item--regular");
      let updatedPrice = `
            <price-money>
                <bdi>
                <bdi><span class="price__prefix">$</span>${prefix}
                </bdi>
            </price-money>
            `;
      priceContainer.innerHTML = updatedPrice;

      if (caseCount) {
        document.querySelector("#unit-price").innerHTML = `$${(convertedNumber / caseCount).toFixed(
          3
        )}`;
      }
    }
  }
}
